import { Dto, DtoWithId } from "@mango/core";
import { Afdeling } from './afdeling';

@Dto({fullName: "CIJBorculo.Logic.Personeel"})
export class Personeel extends DtoWithId {
	oldID: number;
	userID: string;
	naam: string;
	initialen: string;
	voornaam: string;
	tussenvoegsel: string;
	achternaam: string;
	adres: string;
	postcode: string;
	plaats: string;
	telefoon: string;
	mobiel: string;
	eMail: string;
	functie: string;
	afdelingID: Afdeling;
	actief: boolean;
	tijdregistratie: boolean;
	verkoop: boolean;
	inhuur: boolean;
	projectleider: boolean;
	personeelsnummer: number;
}